









import VueOptions from '@utils/VueOptions'
import FormFieldCheckboxButton from '@ui/FormBuilder/FormFields/FormFieldCheckboxButton'

settings =
  name: 'FormFieldStorage'

  vue:
    props: ['value', 'errors']

    components: {
      FormFieldCheckboxButton,
    }

    data: ->
      storage = @value || []
      storage = ['no_storage'] unless storage.length
      { storage }

    computed:
      optionsForStorage: ->
        [
          {
            value: 'standard_storage_available'
            label: 'Standard Storage'
            iconClass: 'fal fa-boxes'
          }
          {
            value: 'climate_controlled_storage_available'
            label: 'Climate Controlled'
            iconClass: 'fal fa-air-conditioner'
          },
          {
            value: 'cold_storage_available'
            label: 'Cold'
            iconClass: 'fal fa-wind'
          },
          {
            value: 'frozen_storage_available'
            label: 'Frozen'
            iconClass: 'fal fa-snowflake'
          },
          {
            value: 'no_storage'
            label: 'No Storage'
            iconClass: 'fal fa-ban'
          }
        ]

    methods:
      hiInputChange: (selectedOptions) ->
        isSelectingNoStorage = selectedOptions[selectedOptions.length - 1] is 'no_storage'
        if isSelectingNoStorage
          storage = []
          @storage = ['no_storage']
        else
          storage = selectedOptions.filter((option) => option isnt 'no_storage')
          @storage = storage
        @$emit 'input', storage
        @$emit 'change', storage

export default VueOptions.vue settings
